import React from 'react';
import C18Button00 from '../../usa/components/C18Button00'
import {cl, getTime,globs} from '../../components/utils/utils';
import {getParamId2} from '../../usa/utils/utils'
import {sendArray} from '../../components/utils/http'
import {dbVals} from '../../components/utils/http'

var js=JSON.stringify

class SaveCancel extends React.Component{


  constructor(props) {
    super(props);
//     this.findDelAuxControl(false).then(v=>{
//       this.setState({sldPos:v})
//     })
//     this.cl2(val)
//     this.cl2(props)
    this.state={
      sldPos:this.getVarMaxMin(),
      ovrEn:false,
    }
    this.props.getValue(props.ind, {type: "saveCancel"})
//     document.addEventListener('touchmove', this.tm);
//     document.body.addEventListener('touchstart', function(e){ e.preventDefault(); });

  }

  cl2=(msg)=>{
    cl(msg)
    let log=this.state.log+"\n"+msg
    this.setState({log:log})
  }

  componentDidMount=()=>{
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveCancel)
    document.addEventListener('touchend', this.mu);
    document.addEventListener('mouseup', this.mu);
    let slider = document.getElementById('slider')
    if (slider) {
      slider.addEventListener('touchstart', this.md, {passive: false});
      slider.addEventListener('touchmove', this.mm, {passive: false});
    }
  }

  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
    document.removeEventListener('touchend', this.mu);
    let slider = document.getElementById('slider');
    if (slider) {
      slider.removeEventListener('touchstart', this.mu);
      slider.removeEventListener('touchmove', this.mu);
    }
    // document.removeEventListener('mouseup', this.mu);
  }

  saveCancel=(cmd)=>{
//     this.cl2(cmd)
    this.props.onChange(
      this.props.ind,
      {value: cmd});
  }

  onButtonClick=(e)=>{
    // this.cl2(e.target.id)
    // let vo
    this.props.onChange(
      this.props.ind,
      {value: e.target.id});
      // {
      // type: "saveCancel",
      // value: e.target.id,
    // })
  }

  setAuxTimer=()=>{
    let st=this.state
    clearTimeout(this.mmTO)
//     this.mmTO=setTimeout(e=>{this.setAuxControl()},3000)
    this.mmTO=setTimeout(e=>{this.setVarMaxMin()},3000)
  }

  auxIds={
    op1TypeId:getParamId2(1900,"configuration_aux_controls","operand1Type"),
    op1ValId:getParamId2(1900,"configuration_aux_controls","operand1Value"),
    op2TypeId:getParamId2(1900,"configuration_aux_controls","operand2Type"),
    op2ValId:getParamId2(1900,"configuration_aux_controls","operand2Value"),
    op3TypeId:getParamId2(1900,"configuration_aux_controls","operand3Type"),
    op3ValId:getParamId2(1900,"configuration_aux_controls","operand3Value"),
    op1Id:getParamId2(1900,"configuration_aux_controls","operator1"),
    op2Id:getParamId2(1900,"configuration_aux_controls","operator2"),
    condId:getParamId2(1900,"configuration_aux_controls","conditionSeconds"),
    actionId:getParamId2(1900,"configuration_aux_controls","action"),
    tarTypeId:getParamId2(1900,"configuration_aux_controls","targetType"),
    tarValId:getParamId2(1900,"configuration_aux_controls","targetValue"),
    actParmId:getParamId2(1900,"configuration_aux_controls","actionParameter"),
    actHoldId:getParamId2(1900,"configuration_aux_controls","actionHoldTime"),
    manModId:getParamId2(1900,"configuration_channel_data","manual_mode"),
    varoMaxId:getParamId2(1900,"configuration_channel_data",
      "CD_analog_max_varout"),
    varoMinId:getParamId2(1900,"configuration_channel_data",
      "CD_analog_min_varout"),
    varoOfsId:getParamId2(1900,"configuration_channel_data",
      "offset"),
  }

//   findDelAuxControl=async(del)=>{
//     let pr=this.props
//     let [z,u,c,i0]=pr.zuci.split("-")
// // op1Val=1, op1Type=10, targetType=6, targetVal=chan,
//     var i
//     for(i=0;i<128;i++){
// //       this.cl2(i,(dbVals.z[+z][i][this.auxIds.op1TypeId]),
// //         (dbVals.z[+z][i][this.auxIds.op1ValId]),
// //         (dbVals.z[+z][i][this.auxIds.tarTypeId]),
// //         (dbVals.z[+z][i][this.auxIds.tarValId]))
//       if((dbVals.z[+z][i][this.auxIds.op1TypeId]==10)&&
//         (dbVals.z[+z][i][this.auxIds.op1ValId]==1)&&
//         (dbVals.z[+z][i][this.auxIds.tarTypeId]==6)&&
//         (dbVals.z[+z][i][this.auxIds.tarValId]==+c)
//       ){
// //         this.cl2(`found ${i}`)
//         if(del){
//           this.cl2("delete")
//           await this.sendAuxCmd(i,+z,0,0,0,0,0)
//         }
//         return dbVals.z[+z][i][this.auxIds.actParmId]
//       }
//     }
//     return 0
// //     return -1
//   }

//   sendAuxCmd=async(auxCtl,z,op1Type,op1Val,tarType,tarVal,actParm)=>{
//     let vals=[
//       {id:this.auxIds.op1TypeId,v:op1Type},
//       {id:this.auxIds.op1ValId,v:op1Val},
//       {id:this.auxIds.op2TypeId,v:0},
//       {id:this.auxIds.op2ValId,v:0},
//       {id:this.auxIds.op3TypeId,v:0},
//       {id:this.auxIds.op3ValId,v:0},
//       {id:this.auxIds.op1Id,v:0},
//       {id:this.auxIds.op2Id,v:0},
//       {id:this.auxIds.condId,v:0},
//       {id:this.auxIds.actionId,v:0},
//       {id:this.auxIds.tarTypeId,v:tarType},
//       {id:this.auxIds.tarValId,v:tarVal},// channel
//       {id:this.auxIds.actParmId,v:actParm},// setting
//       {id:this.auxIds.actHoldId,v:0},
//     ]
//     let arr=vals.map(v=>{
// //       this.cl2(dbVals.z[+z][auxCtl][v.id],v.v)
//       dbVals.z[+z][auxCtl][v.id]=v.v
//       return{
//         c:auxCtl,
//         d:v.v,
//         f:2,
//         i:v.id,
//         t:getTime(),
//         z:+z,
//       }
//     })
// //     this.cl2(arr)
//     await sendArray(arr,false,1900,0,false)
//   }
//
//   setAuxControl=async()=>{
//     let st=this.state
//     let pr=this.props
//     let [z,u,c,i]=pr.zuci.split("-")
//     let auxCtl=100
//     await this.sendAuxCmd(auxCtl,+z,10,1,6,+c,Math.round(st.sldPos))
//   }

//   showSliderO=()=>{
//     let st=this.state
//     let wid=140
//     let mrg=20
//     let topMrg=100
//     let sphD=72
//     let inSldWid=20
//     let sldHgt=this.inSldHgt+sphD
//     let hgt=sldHgt+mrg+topMrg
// //     let sldHgt=hgt-mrg-topMrg
// //     this.cl2(sldHgt)
//     let sldWid=wid-2*mrg
// //     let inSldHgt=this.sldHgt-sphD
// //     this.cl2(this.inSldHgt)
//     let boxHgt=topMrg-2*mrg
//     let boxFnt=boxHgt*.8
//     let boxWid=wid-2*mrg
//     let shdTop="#C0D8F0"//bcd8ed
//     let shdBot="#204080"
//     let boxClr=(st.ovrEn?"#000000":"#EEEEEE")
//     return(
//       <div style={{width:wid,height:hgt,border:"1px solid black",borderRadius:10,
//         position:"relative",backgroundColor:"#FFFFFF",marginBottom:20,marginTop:10,
//         backgroundColor:"#CCCCCC",
//       }}
//       onTouchMove={this.tm} /*onMouseMove={this.mm}*/
//       >
//       {/*box div*/}
//         <div style={{width:boxWid,height:boxHgt,position:"absolute",
//           border:"1px solid black",top:mrg,left:mrg,textAlign:"center",
//           backgroundColor:"white",
//           fontSize:boxFnt,/*color:boxClr,*/cursor:"pointer",}}
//           onClick={e=>{this.setState({ovrEn:!st.ovrEn})}}
//           >
//         {Math.round(st.sldPos)}
//         </div>
//         {/*shaded slider div*/}
//         <div style={{position:"absolute",top:topMrg,left:mrg,width:sldWid,
//           height:hgt-mrg-topMrg,
//           background: `linear-gradient(to bottom, ${shdTop}, ${shdBot})`
//
//         }}>
//         {/*inner slider div*/}
//           <div style={{width:inSldWid,height:this.inSldHgt,top:sphD/2,
//             border:"1px solid black",backgroundColor:"#FFFFFF",
//             left:(sldWid-inSldWid)/2,
//             position:"absolute"
//           }}>
//           </div>
//           {/*sphere div*/}
//           <div style={{left:(sldWid-sphD)/2,top:(1-st.sldPos/100)*this.inSldHgt,
//             position:"absolute"}}
//             onTouchStart={this.td} /*onMouseDown={this.md}*/
//             >
//             <img src="/img/sphereC.png" width={sphD}/>
//           </div>
//         </div>
//       </div>
//     )
//   }

  mdPos=null
  inSldHgt=525
  mmTO=null

  md=(e)=>{
    let st=this.state
    e.preventDefault()
    e.stopPropagation();
    if(e.touches){e=e.touches[0]}
    this.mdPos={x:e.clientX,y:e.clientY,base:st.sldPos}
  }

  mu=(e)=>{
    this.mdPos=null
  }

  mm=(e)=>{
    let st=this.state
    e.preventDefault();
    e.stopPropagation();
    if(e.touches){e=e.touches[0]}
    if(this.mdPos){
      let dif=100*(e.clientY-this.mdPos.y)/(this.inSldHgt*this.sldScale)
      let sldPos=Math.round(this.mdPos.base-dif)
      if(sldPos<0){sldPos=0}
      if(sldPos>100){sldPos=100}
      this.setState({sldPos:sldPos})
      this.setAuxTimer()
    }
    return true
  }

  leftOfs=120
  sldScale=0.55

  showLabels=()=>{
    let labs=[]
    for(let i=0;i<=10;i++){
      let pos=this.sldScale*(580-i*52.5+50)
      labs.push(
        <div key={i}>
        <div key={i} style={{position:"absolute",
          left:this.sldScale*(0-this.leftOfs),top:pos,
          fontSize:this.sldScale*40,fontWeight:700,textAlign:"right"
        }}
        >
        {`${i}V`}
        </div>
        <div key={i+100} style={{position:"absolute",
          left:this.sldScale*(0-this.leftOfs+75),top:pos,
          fontSize:this.sldScale*40,fontWeight:700,textAlign:"right"
        }}
        >
        {`--`}
        </div>
        </div>
        )
    }
    return labs
  }

  setSlidePos=(e)=>{
    this.cl2(e.target.value)
    let val=e.target.value
//     if(isNaN(val)){return}
    this.setState({sldPos:10*val})
    this.setAuxTimer()

  }

  showVal=()=>{
    let st=this.state
    return(
      <input type="number" style={{position:"absolute",width:this.sldScale*100,
        height:this.sldScale*100,padding:0,
        border:"1px solid black",borderRadius:this.sldScale*10,
        left:this.sldScale*(0-this.leftOfs),
        fontSize:this.sldScale*40,textAlign:"center",
      }}
      value={st.sldPos/10}
      step="0.1"
      onChange={this.setSlidePos}
      >
      </input>
    )
  }

  showSlider=()=>{
    let st=this.state
    let slideTop=this.sldScale*(590-5.25*st.sldPos)
    return(
      <div style={{position:"relative",textAlign:"left",left:this.sldScale*this.leftOfs,
        touchAction:"none",
      }}
      >
        {this.showVal()}
        <img src="/img/dimBase.png" width={this.sldScale*400}/>
        <div id="slider" style={{position:"absolute",left:this.sldScale*(-3),top:slideTop,
          touchAction:"none",
        }}
          onMouseMove={this.mm}
          onMouseDown={this.md}
        >
        <img src="/img/dimSlide.png" width={this.sldScale*400}/>
        </div>
        <div style={{width:this.sldScale*this.leftOfs,textAlign:"right"}}>
          {this.showLabels()}
        </div>
      </div>
    )
  }

  enDisManMode=async(en)=>{
    let pr=this.props
    let [z,u,c,i0]=pr.zuci.split("-")
    let arr=[{
      c:+c,
      d:en,
      f:2,
      i:this.auxIds.manModId,
      t:getTime(),
      z:+z,
    }]
    await sendArray(arr,true,1900,0,false)
// function sendArray(arr,virtual,gwType,controllerId,localOnly){
  }

  getVarMaxMin=()=>{
    let pr=this.props
    let [z,u,c,i0]=pr.zuci.split("-")
    return Math.round(10*dbVals.z[+z][+c][this.auxIds.varoMaxId])
  }

  setVarMaxMin=async()=>{// and offset
    let st=this.state
    let val=Math.floor(st.sldPos)/10
    let pr=this.props
    let [z,u,c,i0]=pr.zuci.split("-")
    let sets=[this.auxIds.varoMaxId,this.auxIds.varoMinId,this.auxIds.varoOfsId]
    let arr=sets.map(s=>{
      return{
        c:+c,
        d:(s==this.auxIds.varoOfsId)?0:val,
        f:2,
        i:s,
        t:getTime(),
        z:+z,
      }
    })
    await sendArray(arr,false,1900,0,false)
  }

  toggleEnable=async()=>{
    let pr=this.props
    let curMan=pr.current.manualMode
    if(curMan){
      await this.enDisManMode(false)
//       await this.findDelAuxControl(true)// delete
    }else{
//       this.setAuxTimer()
      await this.enDisManMode(true)
//       await this.setAuxControl()
      this.setState({sldPos:this.getVarMaxMin()})
    }
    let parms={uri:"manualMode",manualMode:!(curMan||false)}
    this.props.rest.parent(parms)
    return
  }

//   showLog=()=>{
// //     cl("showlog")
//     return(
//       <div style={{position:"absolute",top:0,left:0}}>
//       <textarea style={{width:400,height:400}}
//       onChange={this.showLogChange}
//       value={this.state.log||""}
//       />
//       </div>
//     )
//   }

  render(){
//     this.cl2(boxClr)
    let st=this.state
    let pr=this.props
    let mode=(pr.current.manualMode)?"Program":"Manual"
    return(
      <div>
        <C18Button00 type="button" className="filled"
          onClick={this.toggleEnable}
        >{mode} Control</C18Button00><br/><br/>
        {(!!pr.current.manualMode)&&this.showSlider()}
      </div>
    )
  }

}

  export default SaveCancel ;
